export const events = [
    {
        id: 1,
        date: '2025-05-20',
        time: '08:00 AM',
        title: 'Can thiệp San thương Mạn tính: Thách thức và Chiến lược tối ưu',
        // description: 'Phát biểu từ Phúc Tín...',
        location: 'An Giang',
    },
    {
        id: 2,
        date: '2025-06-20',
        time: '08:00 AM',
        title: 'Hình ảnh học Tim mạch: Vai trò và Ứng dụng trong Can thiệp',
        // description: 'Phát biểu của Bs. Đỗ Anh',
        location: 'Cần Thơ',
    },
    {
        id: 3,
        date: '2025-07-19',
        time: '08:00 AM',
        title: 'Quản lý người bệnh suy tim lần thứ 4: "Suy tim và bệnh đồng mắc"',
        // description: 'Phát biểu của đại biểu BV Chợ Rẫy',
        location: 'Khách sạn New World Saigon, TP. Hồ Chí Minh',
    },
    {
        id: 4,
        date: '2025-08-20',
        time: '08:00 AM',
        title: 'Xu hướng mới trong Quản lý Tim mạch và Bệnh lý Chuyển hóa',
        // description: 'Phối hợp Khoa Nội Tiết - BV Chợ Rẫy',
        location: 'Bạc Liêu',
    },
    {
        id: 5,
        date: '2025-09-27',
        time: '08:00 AM',
        title: 'CAN THIỆP SANG THƯƠNG PHÂN NHÁNH MẠCH VÀNH',
        description: 'The 1st MICA-Bifurcation Meeting',
        location: 'Khách sạn Sheraton Cần Thơ',
        isSpecial: true,
    },
    {
        id: 6,
        date: '2025-11-22',
        time: '08:00 AM',
        title: 'Gala Tim mạch Mekong – Tổng kết & Tri ân',
        description: null,
        location: 'Cần Thơ',
        isSpecial: true,
    },
    {
        id: 7,
        date: '2025-12-20',
        time: '08:00 AM',
        title: 'Tổng kết hội nghị thượng đỉnh tim mạch 2025',
        isSpecial: true,
    },
    {
        id: 8,
        date: '2026-05-16',
        title: 'Hội nghị khoa học Tim mạch Can thiệp Mekong lần II – 2026',
        description: 'Tiến bộ và thách thức trong tim mạch',
        isSpecial: true,
        location: 'Khách sạn Hilton Đà Nẵng',
    },
];
